<div class="form-group mb-0">
    <ng-select 
        [isOpen]="isOpen"
        [items]="userRolesListSorted"
        [multiple]="multiselect"
        [loading]="loading"
        [bindLabel]="bindLabel"
        [(ngModel)]="selectedItems"
        [searchable]="true"
        [ngModelOptions]="{standalone: true}"
        [clearSearchOnAdd]="true"
        (close)="rearrangeItems()"
        (change)="emitSelection()"
        dropdownPosition="bottom"
        notFoundText="Nothing here"
        [placeholder]="placeholder"
        [closeOnSelect]="closeOnSelect">

        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div class="d-flex">
                <label class="checkbox checkbox-md">
                    <input id="item-{{index}}" type="checkbox"  name="item-{{index}}" 
                        [ngModel]="item$.selected"
                         />
                    <span
                        (click)="checkUncheck(item$)"></span>
                </label>
                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1 imageAlign"
                    [ngClass]="{'admincolor': index == 0, 'managercolor': index == 1, 'employeecolor': index == 2,
            'contractorcolor': index == 3, 'promanagercolor': index == 4, 'accountantcolor': index == 5, 'clientcolor': index == 6}">
                    <img class="imageAlign mr-1 w-40px h-40px img-fluid rounded bg-primary-o-40 p-1" src="{{item.icon}}" />
                </div>
                <div
                    class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                    <div class="font-weight-bold team-label-name">{{ item.Roles |
                        titlecase }}</div>
                </div>
            </div>

        </ng-template>
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items | slice: 0:2; trackBy: trackByIndex">
                <span class="ng-value-label">{{ item.Roles | titlecase }}</span>
                <span class="ng-value-icon right" (click)="clear(item)"
                    aria-hidden="true">×</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
                <span class="ng-value-label">{{ items.length - 2 }} more...</span>
            </div>
        </ng-template>
    </ng-select>

</div>

